import { useCallback, useContext, useEffect, useState } from "react";
import { doGET } from "../../util/HttpUtil";
import { DialogContext } from "../../store/context/DialogContext";
import DocFieldV2Compact from "./DocFieldV2Compact";
import "./styles.scss";

const DocumentsV2Compact = ({
  label,
  required = true,
  hint,
  record_id,
  field = "",
  asLabel,
  module,
  inline,
  showExpiry,
  getRecordId,
  hideUpload,
  showCategory,
  ubo_id,
  type,
  formId,
  seq,
  enableOnline,
  supportedFiles = ["image", "pdf"],
  single = false,
  error = "",
  validateByAi = false,
  onValidationStatusChange = () => {},
  onDocumentsChanged,
}) => {
  const [documents, setDocuments] = useState([]);
  const { showError } = useContext(DialogContext);

  const fetchDocuments = useCallback(async () => {
    if (module && record_id) {
      try {
        const response = await doGET(
          `/api/file/grid?module=${module}&record_id=${record_id}&${field ? `field=${field}` : ""}`
        );
        if (response.status === 200) setDocuments(response.data?.rows);
      } catch (err) {
        showError("Error", err);
      }
    } else if (record_id) {
      try {
        const response = await doGET(
          `/api/application-doc/grid?rows=-1&form_id=${record_id}&${
            ubo_id ? `ubo_id=${ubo_id}` : ""
          }&${seq ? `seq=${seq}` : ""}&${type ? `type=${type}` : ""}`
        );
        if (response.status === 200) {
          const docs = response.data?.rows;
          const sorted = [...(docs || [])].sort((a, b) => (b?.seq || 0) - (a?.seq || 0));
          const latest = sorted?.[0];
          setDocuments(single ? (latest ? [latest] : sorted) : sorted);
        }
      } catch (err) {
        showError("Error", err);
      }
    }
  }, [field, module, record_id, seq, showError, single, type, ubo_id]);

  useEffect(() => {
    fetchDocuments();
  }, [fetchDocuments]);

  const handleDocumentsChanged = useCallback(async () => {
    await fetchDocuments();
    onDocumentsChanged?.();
  }, [fetchDocuments, onDocumentsChanged]);

  useEffect(() => {
    if (documents?.length === 0) {
      setDocuments([
        { attachment: { name: "", info: "", refNo: "", expanded: true, urls: [] }, expanded: true },
      ]);
    }
  }, [documents]);

  return (
    <div className="docv2__list">
      {documents?.map((doc, index) => (
        <DocFieldV2Compact
          key={
            doc?._id ||
            doc?.attachment?.key ||
            doc?.attachment?.name ||
            `${field || "doc"}-${index}`
          }
          label={label}
          required={required}
          hint={hint}
          showCategory={showCategory}
          showExpiry={showExpiry}
          ubo_id={ubo_id}
          onValidationStatusChange={onValidationStatusChange}
          validateByAi={validateByAi}
          type={type}
          hideUpload={hideUpload}
          onDelete={handleDocumentsChanged}
          onSubmit={handleDocumentsChanged}
          asLabel={asLabel}
          field={field}
          data={doc}
          record_id={record_id}
          getRecordId={getRecordId}
          module={module}
          inline={inline}
          formId={formId}
          seq={seq}
          enableOnline={enableOnline}
          supportedFiles={supportedFiles}
          single={single}
          error={error}
        />
      ))}
    </div>
  );
};

export default DocumentsV2Compact;
